/** @jsxImportSource @emotion/react */
import React from 'react';
import type { DivProps } from 'typings';
import { UDLogo } from 'ud-ui/components';
import * as S from './styles';

interface ILogoStubProps extends DivProps {}

function StubLogo(props: ILogoStubProps) {
  const { ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <UDLogo /> 👍
    </S.MainBlock>
  );
}

export default StubLogo;
